// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e5487e18","337":"ac36e190","453":"f32b78a4","455":"548c657d","767":"d249c964","942":"ad1fc687"}[chunkId] + ".chunk.js";
};